import BigNumber from "bignumber.js";
import * as util from 'ethereumjs-util'
import DataCenter from "../modules/DataCenter";
import { WalletService } from "../modules/WalletService";


export const LongTimeToDateStr = (time) => {
    let date = new Date(time);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;

}

export const LongTimeToTimeStr = (time, hasMin = true, hasSec = true) => {
    let date = new Date(time);
    let hour = date.getHours().toString().padStart(2, '0');
    let minute = date.getMinutes().toString().padStart(2, '0');
    let second = date.getSeconds().toString().padStart(2, '0');

    if (!hasMin) {
        return hour;
    } else if (!hasSec) {
        return `${hour}:${minute}`;
    }

    return `${hour}:${minute}:${second}`;
}

export const LongTimeToFullStr = (time) => {
    return LongTimeToDateStr(time) + " " + LongTimeToTimeStr(time);
}

export const LongTimeToFullStrNoMin = (time) => {
    return LongTimeToDateStr(time) + " " + LongTimeToTimeStr(time, true, false);
}

export const LongTimeToFullStrHourOnly = (time) => {
    return LongTimeToDateStr(time) + " " + LongTimeToTimeStr(time, false, false);
}

const padEndZero = (str, length) => {
    if (length == 0) {
        return str;
    }
    const dot = str.indexOf('.');
    let decimal = 0;
    if (dot >= 0) {
        decimal = str.length - dot;
    }

    if (decimal >= length) {
        return str;
    } else {
        let pad = ''.padEnd(length - decimal, '0');
        if (dot == -1) pad = '.' + pad;
        return str + pad;
    }

}

export const trimZero = (str, decimal = 0) => {
    const dot = str.indexOf('.');
    let trimFrom = -1;
    if (dot >= 0) {
        for (let i = str.length - 1; i >= dot; i--) {
            const n = str[i];
            if (n == '0') {
                trimFrom = i;
            } else {
                break;
            }
        }
    }

    if (trimFrom != -1) {
        if (trimFrom - 1 == dot) {
            //后面全是0
            return padEndZero(str.slice(0, trimFrom - 1), decimal);
        } else {
            return padEndZero(str.slice(0, trimFrom), decimal);
        }
    } else {
        return padEndZero(str, decimal);
    }
}

const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
export const checkEmail = (value) => {
    return regEmail.test(value);
}

const regPwd = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,18}$/
export const checkPwd = (value) => regPwd.test(value)

/**
 * 判断两个地址是否相等
 * @param {String} addr1 
 * @param {String} addr2
 * @return boolean
 */
export const addressEquals = (addr1, addr2) => {
    switch (DataCenter.currentBlockchainId) {
        case 0:
            //eth
            if (!util.isValidAddress(addr1)) {
                return false;
            }
            if (!util.isValidAddress(addr2)) {
                return false;
            }
            const a1 = util.Address.fromString(addr1);
            const a2 = util.Address.fromString(addr2);
            return a1.equals(a2);
        case 1:
            //sol
            return addr1 == addr2;
    }
}

